import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="36" height="36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M23.271 14.5a1 1 0 010 1.414l-5.792 5.793a1 1 0 01-1.456-.043l-2.107-2.377a1 1 0 111.496-1.327l1.403 1.582 5.042-5.042a1 1 0 011.415 0z" fill="#5CD6C0" /><circle cx="18" cy="18" r="11" stroke="#5CD6C0" strokeWidth="2" /></svg>);